import { useState, useCallback } from "react";
import { descargarActasMasivo } from "../../services/participantes/participantesActaServices";

const useDescargaActasFirmadas = () => {
  const [descargando, setDescargando]   = useState(false);
  const [progreso, setProgreso]         = useState(0);
  const [total, setTotal]               = useState(0);
  const [actual, setActual]             = useState(0);
  const [nombreActual, setNombreActual] = useState("");
  const [errores, setErrores]           = useState([]);

  const descargar = useCallback(async (participantes) => {
    if (!participantes?.length) return;

    setDescargando(true);
    setProgreso(0);
    setTotal(participantes.length);
    setActual(0);
    setNombreActual("Generando ZIP en el servidor...");
    setErrores([]);

    try {
      const oids = participantes.map((p) => p.id);

      // Simula progreso mientras el backend genera el ZIP
      setActual(1);
      setProgreso(50);

      await descargarActasMasivo(oids, "actas_firmadas.zip");

      setProgreso(100);
      setActual(participantes.length);

    } catch (error) {
      setErrores(participantes.map((p) => ({
        nombre: p.nombre_completo,
        cedula: p.num_identificacion,
        error: error?.response?.data?.mensaje ?? "Error al descargar",
      })));
    } finally {
      setDescargando(false);
      setProgreso(0);
      setActual(0);
      setTotal(0);
      setNombreActual("");
    }
  }, []);

  return { descargar, descargando, progreso, total, actual, nombreActual, errores };
};

export default useDescargaActasFirmadas;